<div class="modal-header align-items-start border-0">
  <div class="d-flex justify-content-between align-items-center w-100">
    <div class="col-auto">
      <strong class="poppins fs-4">
        {{ type === 'checking' ? 'Conta Corrente' : type === 'credit_card' ? 'Cartão de Crédito' : '' }}
      </strong>
      <p class="fw-semibold fs-5">Últimas Movimentações</p>
    </div>
    <div class="col-auto">
      <div class="bg-white rounded-3 p-3 d-flex flex-column">
        <strong class="fs-7">Saldo atual</strong>
        <div class="d-flex align-items-center gap-2 fw-semibold" [ngClass]="{'text-shadow blurred': hidden}">
          <span class="fs-4">{{0 | currency: 'BRL' : 'symbol' : '1.0'}}</span>
          <span>,{{'00'}}</span>
          <icon-svg (click)="onHidden($event)" svgName="clickable/hide" role="button"
            [tooltip]="hidden ? 'Mostrar valor' : 'Esconder valor'"></icon-svg>
        </div>
      </div>
    </div>
  </div>
  <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
</div>
<div class="modal-body">
  <div class="table-responsive">
    <table class="table table-hover table-borderless align-middle">
      <thead class="table-warning">
        <tr>
          <th>Data</th>
          <th>Histórico</th>
          <th>Banco / Bandeira</th>
          <th class="text-end">Valor</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of transactions | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems }">
          <td data-label="Data">{{item.transaction_date | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
          <td data-label="Histórico">{{item.name}}</td>
          <td data-label="Banco / Bandeira">{{item?.bank_name}}</td>
          <td data-label="Valor" class="text-end"
            [ngClass]="{'text-danger': item.amount < 0, 'text-success': item.amount > 0}">
            {{item.amount | currency: 'BRL' : 'symbol' : '1.2-2'}}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-12 mt-3 d-flex justify-content-end align-items-center">
      <pagination-controls class="custom-pagination" (pageChange)="pageChanged($event)" [maxSize]="12"
        responsive="true" autoHide="true" (pageBoundsCorrection)="pageChanged($event)" directionLinks="true"
        previousLabel="" nextLabel="">
      </pagination-controls>
      <div class="form-group">
        <select [(ngModel)]="itemsPerPage" (change)="pageChanged(1)"
          class="form-control form-control-sm bg-light border-0 ms-3">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="15">15</option>
          <option [ngValue]="20">20</option>
        </select>
      </div>
      <div class="poppins fs-8 my-0 ms-2 text-secondary">Itens por página</div>
    </div>
  </div>
</div>